import { type MouseEvent, useId, useMemo, useState } from 'react'

export function useMenuPopup() {
	const menu = useId()

	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

	const isOpen = Boolean(anchorEl)

	const methods = useMemo(
		() => ({
			closeMenu() {
				setAnchorEl(null)
			},

			openMenu(event: MouseEvent<HTMLButtonElement>) {
				setAnchorEl(event.currentTarget)
			}
		}),
		[]
	)

	return {
		isOpen,
		menuCn: `${menu}-menu`,
		triggerCn: `${menu}-trigger`,
		...methods,
		anchorEl
	}
}
